export const LAYERS = {
  AIRCRAFT: "aircraft-layer",
  TRAILS: "trails-layer",
  TRACKS: "tracks-layer",
  // 🌟 INTERCEPT is now unused — InterceptManager/Updater were replaced by
  // PrimitivesManager/Updater. Safe to remove once you've confirmed nothing
  // else in the codebase (e.g. layer style definitions) still references it.
  INTERCEPT: "intercept-layer",
  SILOS: "silos-layer",
  DRONES: "drones-layer",
  PDARS: "pdars-layer",
  PDAR_AOA: "pdar-aoa-layer",
  // Primitives: one shared source fanned out into a fill layer (shapes) and
  // three line layers (one per dash style, since line-dasharray isn't data-driven).
  PRIMITIVES_FILL: "primitives-fill-layer",
  PRIMITIVES_LINE_SOLID: "primitives-line-solid-layer",
  PRIMITIVES_LINE_DASHED: "primitives-line-dashed-layer",
  PRIMITIVES_LINE_DOTTED: "primitives-line-dotted-layer",
  HEATMAP: "heatmap-layer",
} as const;
